import { render, staticRenderFns } from "./prensa.vue?vue&type=template&id=095a6996&scoped=true"
import script from "./prensa.vue?vue&type=script&lang=js"
export * from "./prensa.vue?vue&type=script&lang=js"
import style0 from "./prensa.vue?vue&type=style&index=0&id=095a6996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095a6996",
  null
  
)

export default component.exports